import { render } from "./RelationVocabularyGate.vue?vue&type=template&id=2a3b45b1&scoped=true&ts=true"
import script from "./RelationVocabularyGate.vue?vue&type=script&lang=ts"
export * from "./RelationVocabularyGate.vue?vue&type=script&lang=ts"

import "./RelationVocabularyGate.vue?vue&type=style&index=0&id=2a3b45b1&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a3b45b1"]])

export default __exports__